import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

const authSlice = createSlice({
  name: "auth",
  initialState: null,
  reducers: {
    FETCHED_USER: (state, action) => {
      return action.payload;
    },
    REMOVED_USER: (state, action) => {
      return null;
    },
    UPDATE_USER: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { FETCHED_USER, REMOVED_USER, UPDATE_USER } = authSlice.actions;

export default authSlice.reducer;

// Selectors

const selectState = (state) => state;

export const selectUser = createSelector(selectState, (el) => el.auth);
